import { CONFIG_UPDATE } from 'Reducers/config/types';
import * as analyticsManager from 'Utilities/analytics/analyticsManager';
import { generateLibreUserAgentHeader, setUrls, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { setSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
import { getLibreConfigService } from 'Services/libre_api';
import { normalizeLibreConfig, normalizeLibreSharingConfig } from './normalizer';
export const getConfig = (country, app, pId) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.libreSharingApiCountryUrl + 'v1/config',
      headers: {
        'X-User-Agent': app
      },
      params: {
        country,
        pId
      }
    }).then(result => {
      if (result.data) {
        return resolve(result.data);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const updateConfig = async (countryParam = 'US', app = 'insulet', pId = 'none') => {
  const country = countryParam.toUpperCase();
  const config = await getConfig(country, app, pId);
  const normalizedConfig = normalizeLibreSharingConfig(config);
  setUrls(normalizedConfig, country);
  store.dispatch({
    type: CONFIG_UPDATE,
    config: normalizedConfig
  });
  setSessionObject('config', normalizedConfig);
  setSessionObject('env', {
    country,
    app,
    pId
  });
  analyticsManager.initialize(normalizedConfig.analytics);
};
export const updateLibreConfig = async (countryParam = 'US', app, appVersion, osType, osVersion) => {
  const country = countryParam.toUpperCase();
  const xUserAgent = generateLibreUserAgentHeader(app, appVersion, osType, osVersion);
  const config = await getLibreConfigService({
    country,
    xUserAgent
  });
  const normalizedConfig = normalizeLibreConfig(config);
  setUrls(normalizedConfig, country);
  store.dispatch({
    type: CONFIG_UPDATE,
    config: normalizedConfig
  });
  setSessionObject('config', normalizedConfig);
  setSessionObject('env', {
    country,
    app,
    appVersion,
    osType,
    osVersion
  });
  analyticsManager.initialize(normalizedConfig.analytics);
};